import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import {mask} from 'vue-the-mask'
import '@fortawesome/fontawesome-free/css/all.min.css'
import './styles/main.css'  // We'll make this next
import './firebase'
createApp(App).use(router).directive('mask', mask).mount('#app')
// This is the main entry point of the Vue application.